import { Routes } from '@angular/router';
import { Role } from '../../core/enums/role.enum';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';

const MIGALHAS_BASE = [
  { label: 'Recesso', url: '/recesso' },
  { label: 'Analisar solicitações', url: '/recesso/analisar' },
];

export const analisarRecessoRoutes: Routes = [
  {
    path: 'recesso/analisar',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./analisar-recesso.component').then((m) => m.AnalisarRecessoComponent),
        data: {
          title: 'Analisar Solicitação de Recesso',
          roles: [Role.RECESSO_ANALISAR_CONSULTAR],
          breadcrumb: MIGALHAS_BASE,
        },
      },
      {
        path: ':programaId/profissional/:profissionalId',
        loadComponent: () => import('./detalhe/detalhe-analise.component').then((m) => m.DetalheAnaliseComponent),
        data: {
          title: 'Analisar Solicitação de Recesso',
          roles: [Role.RECESSO_ANALISAR_VISUALIZAR],
          // O último item é trocado pelo nome do profissional (BreadcrumbDinamicoService) ao carregar o detalhe.
          breadcrumb: [...MIGALHAS_BASE, { label: 'Profissional' }],
        },
      },
    ],
  },
];
